import { Link } from "react-router-dom";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import Modal from "react-modal";
import Button from "@mui/material/Button";

import "./Style.css";

if (process.env.NODE_ENV !== "test") Modal.setAppElement("#root");

class ModalWrapper extends Component<any, any> {
    constructor(props: any) {
        super(props);

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.props.setModalOpen(true);
    }

    closeModal() {
        this.props.setModalOpen(false);
    }

    render() {
        let textTitle = this.props.openTitle;
        if (this.props.openTitle === "") {
            textTitle = <i className="fa fa-plus" aria-hidden="true"></i>
        }
        
        let link = (
            <Button
                variant="contained"
                color="primary"
                disableElevation
                onClick={this.openModal}
            >
                {textTitle}
            </Button>
        );

        if (this.props.look == "text") {
            link = (
                <Button disableElevation onClick={this.openModal}>
                    <i className="fa fa-plus" aria-hidden="true"></i>&nbsp;
                    {this.props.openTitle}
                </Button>
            );
        }

        if (this.props.look == "bareblock") {
            link = (
                <span>
                    <i className="fa fa-plus" aria-hidden="true"></i>
                    <span className="new-link">{this.props.openTitle}</span>
                </span>
            );
        }

        return (
            <span>
                {link}
                <Modal
                    isOpen={this.props.modalIsOpen}
                    onRequestClose={this.closeModal}
                    className="modquiz-modal"
                    overlayClassName="modquiz-modal-overlay"
                    contentLabel={this.props.modalTitle || this.props.openTitle}
                >
                    <div className="Modal">
                        <button className="close" onClick={this.closeModal} aria-label="Close dialog">
                            &times;
                        </button>
                        {React.cloneElement(
                            this.props.children as React.ReactElement<any>,
                            { closeModal: this.closeModal }
                        )}
                    </div>
                </Modal>
            </span>
        );
    }
}

export default ModalWrapper;
